/*************styles from wp*********/
import "./public/themeStylesheet.css"
import "@webdeveducation/wp-block-tools/dist/css/style.css";
import "./src/common/css/font.css";
import "./src/common/css/main.css?adutlaekuaemhpfv";
import "./src/common/css/main-ar.css";
import "./src/common/css/facelift.css";
import "./src/common/css/media.css?asdf=asvdgef";
import "./src/common/css/bootstrap.css";
import "./src/common/css/mapplic.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./src/common/css/reset-gutenberg.css";
import "./src/common/css/gutenberg-style.css?adsf=asoprdf";


const CMS_BASE_URL = "https://cms.alj3.clients.lemonhq.io/wp-content/themes/alj/common";


export const onClientEntry = () => {
  // CSS files
  const stylesheets = [
    `${CMS_BASE_URL}/css/blocks/profile-quote.css`,
  ];

  stylesheets.forEach((href) => {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  });

};